<script>
    import Button from "vpap/svelte/Button.svelte";
    import Svg from "vpap/svelte/Svg.svelte";
    import {activeData, currentRound} from "./stores";
    export let itemWidth;

    $: roundInfo = $activeData.rounds_overview.find(d => d.number === $currentRound);
    let activeSection = "num_ballots";
    $: maxVal = Math.max(
        ...$activeData.redistributed_votes[$currentRound].map(d => d[activeSection]),
        activeSection === "num_ballots" ? roundInfo.no_choice : -Infinity
    );

    const barHeight = 25;
    const textHeight = 24;
    $: maxLength = itemWidth - 100;

    $: chartHeight = (barHeight + textHeight) * ($activeData.redistributed_votes[$currentRound].length) + (activeSection === "num_ballots" ? barHeight + textHeight : 0);

    function sortFunc(a, b) {
        if (a[activeSection] < b[activeSection]) return 1;
        else if (a[activeSection] > b[activeSection]) return -1;
        else {
            if (a.cand_name.toLowerCase() < b.cand_name.toLowerCase()) return -1;
            else if (a.cand_name.toLowerCase() > b.cand_name.toLowerCase()) return 1;
            else return 0;
        }
    }
</script>

{#if roundInfo.last_eliminated}
<div class="sr-only">Click the buttons below to toggle between seeing the redistributed votes by the number of ballots cast and by the number of weighted votes.</div>
<div class="btn-container">
    <Button fontColor="#607482" isActive={activeSection === "num_ballots"} on:click={() => activeSection = "num_ballots"}>
        Ballots Cast
    </Button>
    <Button fontColor="#607482" isActive={activeSection === "votes"} on:click={() => activeSection = "votes"}>
        Weighted Votes
    </Button>
</div>
<div class="last-eliminated">
    <b>{roundInfo.last_eliminated}</b>&nbsp;was eliminated in Round {$currentRound - 1}. 
    Based on delegates' next preference, {roundInfo.last_eliminated_last}'s {#if activeSection === "num_ballots"}ballots{:else}weighted votes{/if} were redistributed as follows.
</div>
<div class="bar-chart">
    <Svg
        width={itemWidth} 
        height={chartHeight}
        description={`A bar chart showing the ${activeSection === "num_ballots" ? "number of ballots" : "number of weighted votes"} that were redistributed to each of the remaining candidates.`}
        titleId="redistributed-votes-bar-chart"
        role="graphics-document"
    >
        {#each $activeData.redistributed_votes[$currentRound].sort(sortFunc) as cand, idx}
            <g class="cand-bar" transform={`translate(0, ${idx * (barHeight + textHeight)})`}>
                <text y="17">{cand.cand_name}</text>
                <rect 
                    y={textHeight} 
                    width={maxLength * (cand[activeSection] / maxVal)} 
                    height={barHeight} 
                    fill={cand.cand_color}
                    aria-hidden="true"
                ></rect>
                <text x={maxLength * (cand[activeSection] / maxVal) + 3} y={textHeight + 18} class="cand-redistributed">+{cand[activeSection].toLocaleString("en")} <tspan fill="none">{activeSection === "num_ballots" ? "votes redistributed" : "weighted ballots redistributed"}</tspan></text>
            </g>
        {/each}
        {#if activeSection === "num_ballots"}
        <g class="cand-bar" transform={`translate(0, ${$activeData.redistributed_votes[$currentRound].length * (barHeight + textHeight)})`}>
            <text y="17">No Choice</text>
            <rect
                y={textHeight}
                width={maxLength * (roundInfo.no_choice / maxVal)}
                height={barHeight}
                fill="#596e7c"
                aria-hidden="true"
            ></rect>
            <text x={maxLength * (roundInfo.no_choice / maxVal) + 3} y={textHeight + 18} class="cand-redistributed">
                +{roundInfo.no_choice.toLocaleString("en")}
                <tspan fill="none">{activeSection === "num_ballots" ? "votes redistributed" : "weighted ballots redistributed"}</tspan>
            </text>
        </g>
        {/if}
    </Svg>
    {#if activeSection === "num_ballots"}
    <div class="notes">
        <p>No choice refers to voters who only selected candidates who have been eliminated.
        </p>
    </div>
    {/if}
</div>
{/if}

<style lang="scss">
    .last-eliminated {
        margin-bottom: 1em;
    }

    text {
        fill: #596e7c;

        &.cand-redistributed {
            font-weight: bold;
            font-size: 1.1rem;
        }
    }

    .notes {
        font-size: .9rem;
        margin-top: .7em;
    }

    .btn-container {
        margin-bottom: 15px;
    }
</style>